import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
function Home() {
  const history = useNavigate()
  useEffect(()=>{
if(localStorage.getItem('Vediocalltoken')){
  const token = JSON.parse(localStorage.getItem("Vediocalltoken"))._id
  history(`/contact/?_id=${token}`)
}
  },[])
  return (

<>
<div className="landing_home">
      <h1>Interactive Chat 
         & Streaming</h1>
    </div>
    <footer className='footer_main'>

</footer>
</>    )
}

export default Home